import {Label} from '@primer/react'

import labelStyles from '../EntryStatusLabel.module.css'
import {EffectiveEntryStatus} from '../../../../helpers/effective-entry-status'
import type {EffectiveEntryStatus as EffectiveEntryStatusType} from '../../../../helpers/effective-entry-status'

export function DraftStatusLabel({status}: {status: EffectiveEntryStatusType}) {
  if (status !== EffectiveEntryStatus.Draft) return null

  return (
    <Label variant="secondary" className={labelStyles.solid}>
      Draft
    </Label>
  )
}
